// @ts-nocheck
/* eslint-enable */
// Actions
import AreaActions from 'app/shared/flux/actions/AreaActions';
import ErrorActions from 'app/shared/flux/actions/ErrorActions';
import { MapActions_fetchStaticMap } from 'app/shared/flux/actions/MapActions';

const loadAreaPage = (reactContext, { areaResourceId }) => {
  const { store, trace } = reactContext;

  return store
    .dispatch(AreaActions.loadAreaPage(areaResourceId))
    .then((response) => {
      trace.finishAsyncSpan({
        marker: 'FetchAreaWrapper#AreaActions#loadAreaPage',
      });

      if (response.error) {
        if (response.redirect && response.to) {
          return response;
        }

        store.dispatch(
          AreaActions.setCurrentArea({
            status: 'DATA_NOT_FOUND',
          }),
        );
        return {
          changeHttpStatus: 404,
        };
      }

      return response;
    })
    .then(async (response) => {
      const query = store.getState().location.current.query;
      await store.dispatch(MapActions_fetchStaticMap({ area: response, query }));

      return response;
    })
    .catch((error) => {
      store.dispatch(
        ErrorActions.errorHandler({
          error,
          errorLocation: 'component.areaPage.serverRouteWillMount#loadAreaPage',
          errorClass: 'AreaActions',
        }),
      );
    });
};

export default loadAreaPage;
